import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { GRETA_THINKING_TICK_MS } from '../../GretaAIChat.constants'

import {
  getGretaAIChatElapsedLabel,
  getGretaAIChatElapsedMs,
  getGretaAIChatThinkingStageTextKey,
} from './useGretaAIChatThinkingStatus.utils'

export function useGretaAIChatThinkingStatus({
  turnStartedAt = null,
} = EMPTY_OBJECT) {
  const { t } = useTranslation()

  const [elapsedMs, setElapsedMs] = useState(0)

  useEffect(() => {
    function updateElapsed() {
      setElapsedMs(getGretaAIChatElapsedMs(turnStartedAt))
    }

    updateElapsed()

    const intervalId = window.setInterval(updateElapsed, GRETA_THINKING_TICK_MS)

    return () => window.clearInterval(intervalId)
  }, [turnStartedAt])

  return {
    elapsedLabel: getGretaAIChatElapsedLabel(t, elapsedMs),
    text: t(getGretaAIChatThinkingStageTextKey(elapsedMs)),
  }
}
